(function () {
  'use strict';

  /* Mobile menu */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    btn.addEventListener('click', function () {
      var open = !nav.hidden;
      nav.hidden = open;
      btn.setAttribute('aria-expanded', String(!open));
      btn.querySelectorAll('[data-icon]').forEach(function (i) { i.hidden = !i.hidden; });
    });
  });

  /* Cookie banner */
  var KEY = 'cc_cookie_consent';
  var banner = document.querySelector('[data-cookie-banner]');
  if (banner) {
    var choice = null;
    try { choice = localStorage.getItem(KEY); } catch (e) {}
    /* Keep the mobile sticky buy bar clear of the consent banner: both are
       fixed to the bottom and the banner sits above it. */
    var liftStickyBar = function () {
      if (banner.hidden) {
        document.body.classList.remove('cc-has-consent');
        document.body.style.removeProperty('--cc-consent-h');
      } else {
        document.body.classList.add('cc-has-consent');
        document.body.style.setProperty('--cc-consent-h', banner.offsetHeight + 'px');
      }
    };
    if (!choice) banner.hidden = false;
    liftStickyBar();
    if ('ResizeObserver' in window) new ResizeObserver(liftStickyBar).observe(banner);
    window.addEventListener('resize', liftStickyBar);
    banner.querySelectorAll('[data-consent]').forEach(function (b) {
      b.addEventListener('click', function () {
        try { localStorage.setItem(KEY, b.getAttribute('data-consent')); } catch (e) {}
        banner.hidden = true;
        liftStickyBar();
      });
    });
  }

  /* Copy support email */
  document.querySelectorAll('[data-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var text = btn.getAttribute('data-copy');
      var label = btn.querySelector('[data-copy-label]');
      var done = function () {
        btn.querySelectorAll('[data-icon]').forEach(function (i) { i.hidden = !i.hidden; });
        if (label) label.textContent = 'Copied';
        setTimeout(function () {
          btn.querySelectorAll('[data-icon]').forEach(function (i) { i.hidden = !i.hidden; });
          if (label) label.textContent = text;
        }, 2000);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(text).then(done, done); else done();
    });
  });

  /* Product form: variants, price, gallery */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent || '[]');
    var selects = root.querySelectorAll('[data-option-select]');
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var addBtn = root.querySelector('[data-add]');
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var mainImg = root.querySelector('.cc-gallery__main img');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var stickyBar = root.querySelector('[data-stickybuy]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyAdd = root.querySelector('[data-sticky-add]');

    function money(cents) {
      var v = (cents / 100).toFixed(2);
      var parts = v.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, parts.join('.'));
    }

    function showMedia(id) {
      var t = root.querySelector('[data-thumb][data-media-id="' + id + '"]');
      if (t) t.click();
    }

    function current() {
      var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var v = current();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (stickyAdd) {
        stickyAdd.disabled = !v.available;
        stickyAdd.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (!mainImg) return;
        mainImg.style.opacity = '0';
        var src = t.getAttribute('data-src');
        var srcset = t.getAttribute('data-srcset');
        var box = root.querySelector('[data-gallery-main]');
        if (box && t.getAttribute('data-ratio')) box.style.aspectRatio = t.getAttribute('data-ratio');
        setTimeout(function () {
          mainImg.src = src;
          if (srcset) mainImg.srcset = srcset;
          mainImg.alt = t.getAttribute('data-alt') || '';
          mainImg.style.opacity = '1';
        }, 150);
        thumbs.forEach(function (x) { x.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
      });
    });

    if (variants.length > 1) update();

    /* Sticky bar = fastest path to checkout: add via AJAX, then go straight to
       /checkout. Falls back to a normal form submit (-> /cart) if JS or the
       request fails, so the button is never a dead end.
       Also falls back on a timeout: Meta's in-app browser (Facebook/Instagram)
       can suspend JS execution mid-request during navigation, leaving the
       fetch promise never resolving or rejecting -- without this, the button
       would stay stuck on "Adding..." indefinitely for that visitor. */
    var buyNow = root.querySelector('[data-sticky-buynow]');
    if (buyNow) {
      buyNow.addEventListener('click', function (e) {
        if (buyNow.disabled) return;
        if (!window.fetch) return;            // no fetch: let the form submit
        var v = current();
        var vid = v ? v.id : (idInput && idInput.value);
        if (!vid) return;                     // unknown variant: let it submit
        e.preventDefault();
        var label = buyNow.textContent;
        buyNow.disabled = true;
        buyNow.textContent = 'Adding\u2026';
        var settled = false;
        var fallback = function () {
          if (settled) return;
          settled = true;
          buyNow.disabled = false;
          buyNow.textContent = label;
          if (addBtn) addBtn.click();          // fall back to the normal path
        };
        var timeoutId = setTimeout(fallback, 4000);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        }).then(function (r) {
          if (settled) return;
          clearTimeout(timeoutId);
          settled = true;
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        }).catch(function () {
          clearTimeout(timeoutId);
          fallback();
        });
      });
    }

    /* Sticky buy bar: show once the in-page Add to cart is out of view */
    if (stickyBar && addBtn) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          stickyBar.hidden = entries[0].isIntersecting;
        }, { rootMargin: '0px 0px -64px 0px' }).observe(addBtn);
      } else {
        stickyBar.hidden = false;
      }
    }
  });
})();
